import { EmployeeDetails } from "../../../serviceoperation/entity/EmployeeOperationEntity";

export const buildInitialValues = (employee?: EmployeeDetails) => {
  if (!employee) return undefined;

  return {
    firstName: employee.firstName,
    lastName: employee.lastName,
    role: employee.permissions?.[0] ?? null,
    employeeID: employee.employeeId,
    locationId: employee.organization?.branchId ?? null,
    departmentId: employee.organization?.departmentId ?? null,
    email: employee.email ?? null,
    phone: employee.phone ?? null,
    managerId: employee.managerId ?? null,
    isSyncEnabled: employee.isSyncEnabled ?? false,
  } as Record<string, unknown>;
};